import Color from '@base/features/game/model/color';
import Animation from './animation';
import { ICheckerView, IGameLine } from './interfaces';
import { Coordinates } from '@base/features/game/model/types';
import ImageProvider from '@base/features/image/imageProvider';
import { BackgammonImageCollectionKeys } from '@backgammon/constants/imageCollection';
import Drawable from '@base/features/game/model/drawable';

export default class CheckerView extends Drawable implements ICheckerView {
  private _animation: Animation | undefined = undefined;
  private isAnimating = false;

  constructor(
    private color: Color,
    private imageProvider: ImageProvider<BackgammonImageCollectionKeys>,
    context: CanvasRenderingContext2D
  ) {
    super(context);
    this.color = color;
    this.animation = undefined;
    this.updateColor();
  }

  setColor(color: Color) {
    this.color = color;
    this.updateColor();
  }

  getColor() {
    return this.color;
  }

  createAnimation(
    fromCords: Coordinates,
    toCords: Coordinates,
    speed: number,
    startTime: number,
    toLine: IGameLine,
    onAnimationEnd: Function
  ) {
    this._animation = new Animation(this, fromCords, toCords, speed, startTime, toLine, onAnimationEnd);
  }

  performAnimation(currentTime: number) {
    if (this.isAnimating) {
      currentTime = new Date().getTime();
      if (!this._animation) {
        this.setAnimating(false);
        return;
      }
      this.position = this._animation.getCurrentPosition(currentTime);
    }
  }

  setAnimating(isAnimating: boolean) {
    this.isAnimating = isAnimating;
  }

  set animation(animation: Animation | undefined) {
    this._animation = animation;
  }

  get animation() {
    return this._animation;
  }

  updateColor() {
    this.image =
      this.color === Color.Black
        ? this.imageProvider.get('CheckerBlack')
        : this.imageProvider.get('CheckerWhite');
  }
}
